export function haversineDistanceKm(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// Straight-line distance understates the real walking route, so scale by a
// detour factor before applying an average walking speed.
const WALK_SPEED_KMH = 5;
const ROUTE_DETOUR_FACTOR = 1.3;

export function estimateWalkMinutes(distanceKm) {
  const minutes = ((distanceKm * ROUTE_DETOUR_FACTOR) / WALK_SPEED_KMH) * 60;
  return Math.max(1, Math.round(minutes));
}

export function sortByDistance(items, origin) {
  if (!origin) return items;
  return [...items]
    .map((item) => ({ ...item, distanceKm: haversineDistanceKm(origin, item) }))
    .sort((a, b) => a.distanceKm - b.distanceKm);
}
